import { useQuery } from '@tanstack/react-query'

import { NotificationQuery } from './NotificationQuery'

export const ticketChatUserNotificationQuery: NotificationQuery = {
  getNotificationsQueryKey() {
    return ['ws', 'ticketChat', 'notificationCount']
  },

  useNotificationsQuery() {
    return useQuery<number>({
      queryKey: this.getNotificationsQueryKey(),
      queryFn: () => 0,
      staleTime: Infinity
    })
  }
}
